import { render } from "./nav-account.vue?vue&type=template&id=9b2eea8e"
import script from "./nav-account.vue?vue&type=script&lang=js"
export * from "./nav-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__